import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Button } from '@mui/material';
import { useOrganizationContext } from '../../../context/organization_context/OrganizationContext';
import { CloudFunctions } from '../../../utils/enums/CloudFunctions'
import { StringKeys } from '../../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';
import { Loading } from '../../../components/loading/Loading';
import LoadingData from '../../../components/loading/LoadingData';

function StripeOnboarding() {
    const functions = getFunctions();
    const [accountLink, setAccountLink] = useState('');
    const { organizationStripeInfo } = useOrganizationContext()
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const handleOnboard = async () => {
        try {
            setLoading(true);
            const createStripeAccountLink = httpsCallable(functions, CloudFunctions.CreateStripeAccountLink);
            const result = await createStripeAccountLink({ accountId: organizationStripeInfo.stripe_account_id, origin: window.location.origin });
            if (result.data.success) {
                setAccountLink(result.data.url);
                window.open(result.data.url, '_blank');
            } else {
                console.error(result.data.error);
            }
        } catch (error) {
            console.error('Error onboarding with Stripe:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        loading ? 
            (
                <LoadingData />
            ) : (
                <div>
                    <Button variant="contained" color="primary" onClick={handleOnboard}>
                        {t(StringKeys.ONBOARD_WITH_STRIPE)}
                    </Button>
                </div>
            )
    );
}

export default StripeOnboarding;